import { getCachedShow, cacheShow } from './cacheService';

const OMDB_API_KEY = import.meta.env.VITE_IMDB_API_KEY;
const API_URL = 'https://www.omdbapi.com/';

export const getIMDbRating = async (imdbId) => {
  if (!imdbId) return null;
  
  try {
    const response = await fetch(
      `https://www.omdbapi.com/?i=${imdbId}&apikey=${OMDB_API_KEY}`
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch IMDb rating');
    }

    const data = await response.json();
    return data.imdbRating;
  } catch (error) {
    console.error('Error fetching IMDb rating:', error);
    return null;
  }
};

export const getIMDbDetails = async (imdbId) => {
  try {
    const response = await fetch(`https://www.omdbapi.com/?i=${imdbId}&apikey=${OMDB_API_KEY}`, {
      mode: 'cors',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      console.warn(`OMDB API returned ${response.status} for ID: ${imdbId}`);
      return null;
    }

    const data = await response.json();
    
    // Log the raw response for debugging
    console.log('OMDB API Response:', {
      imdbId,
      type: data.Type,
      rawData: data
    });

    if (data.Error) {
      console.warn('OMDB API returned error:', data.Error);
      return null;
    }

    return data;
  } catch (error) {
    console.warn('Error fetching IMDb details:', error);
    // Return null instead of throwing to prevent cascade failures
    return null;
  }
};

export const searchShows = async (query, page = 1, filter = 'all') => {
  try {
    const response = await fetch(
      `https://www.omdbapi.com/?s=${encodeURIComponent(query)}&page=${page}&apikey=${OMDB_API_KEY}`,
      {
        mode: 'cors',
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(`OMDB API returned ${response.status}`);
    }

    const data = await response.json();
    
    if (data.Error) {
      console.warn('OMDB search returned error:', data.Error);
      return { results: [], hasMore: false };
    }

    // Filter results based on type if needed
    let results = data.Search || [];
    if (filter !== 'all') {
      results = results.filter(show => {
        const showType = show.Type?.toLowerCase();
        if (filter === 'movie') {
          return showType === 'movie' || showType === 'film';
        }
        return showType === 'series';
      });
    }

    // Transform and log each result
    const transformedResults = results.map(show => {
      const transformed = {
        id: show.imdbID,
        title: show.Title,
        year: show.Year,
        type: show.Type,
        poster: show.Poster !== 'N/A' ? show.Poster : null
      };
      
      console.log('Transformed search result:', transformed);
      return transformed;
    });

    return {
      results: transformedResults,
      hasMore: data.totalResults > page * 10
    };
  } catch (error) {
    console.error('Error searching shows:', error);
    return { results: [], hasMore: false };
  }
}; 